exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dayTime-container[data-v-029db4d3] {\n  display: inline-block;\n  border-bottom: 1px solid #ddd;\n  margin-right: 10px;\n  width: calc((100% - 30px) / 4);\n  min-width: 100px;\n}\n.dayTime-container .dayTime-element[data-v-029db4d3] {\n    width: calc(100% - 2px);\n}\n.dayTime-container[data-v-029db4d3]:last-child {\n  margin-right: 0;\n}\n", ""]);

// exports
